import React, {useEffect, useRef, useState} from 'react';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Container,
    Step,
    StepLabel,
    Stepper
} from "@mui/material";
import FunctionsData from "../Functions/FunctionsData";
import logo from '../img/community_desexing.png';
import CommunityStep4Final from "./LandingCommunity/CommunityStep4Final";
import CommunityStep3 from "./LandingCommunity/CommunityStep3";
import CommunityStep1 from "./LandingCommunity/CommunityStep1";
import CommunityStep0 from "./LandingCommunity/CommunityStep0";
import CommunityStep from "./LandingCommunity/CommunityStep";
import CommunityStep2 from "./LandingCommunity/CommunityStep2";
import CommunityStartPage from "./LandingCommunity/CommunityStartPage";
import OutreachStartPage from "./LandingCommunity/OutreachStartPage";

const jwtKey = process.env.REACT_APP_JWT_KEY;
const defaultLogo = 'https://www.dropbox.com/s/tjdta5zikpage2h/default.png?dl=1';

const StepperComponent = (props) => {
    // console.log(props)

    const [vetName, setVetName] = useState('Select Vet');
    const [currentVet, setCurrentVet] = useState(0);
    const [currentVetArr, setCurrentVetArr] = useState([]);
    const [aStep, setAStep] = useState(0);
    const [cmpId, setcmpId] = useState(0);
    const [postCode, setPostcode] = useState('');
    const [googlePlace, setGooglePlace] = useState([]);
    const [frmFn, setFrmFn] = useState('');
    const [frmLn, setFrmLn] = useState('');
    const [frmStreet, setFrmStreet] = useState('');
    const [frmStreetNumber, setFrmStreetNumber] = useState('');
    const [frmCity, setFrmCity] = useState('');
    const [frmDPID, setFrmDPID] = useState(0);
    const [frmEmail, setFrmEmail] = useState('');
    const [frmPhone, setFrmPhone] = useState('');
    const [formattedAddress, setFormattedAddress] = useState('');
    const [suburb, setSuburb] = useState('');
    const [animals, setAnimals] = useState([]);
    const [frmCampaign, setFrmCampaign] = useState(0);
    const [frmMarketingOptin, setFrmMarketingOptin] = useState('');
    const [frmOrderID, setFrmOrderID] = useState(0);

    const [postcodes, setPostcodes] = useState([]);
    const [loadingPostcodes, setLoadingPostcodes] = useState(true);

    const [vets, setVets] = useState([]);

    const [sponsorId, setSponsorId] = useState(0);
    const [sponsorName, setSponsorName] = useState('');
    const [sponsorProgram, setSponsorProgram] = useState('');
    const [sponsorCost, setSponsorCost] = useState(0.00);
    const [sponsorMicrochipExtraCost, setSponsorMicrochipExtraCost] = useState(0.00);
    const [sponsorEmailText, setSponsorEmailText] = useState('');
    const [sponsorLogo, setSponsorLogo] = useState(defaultLogo);
    const [isSpcaEntered, setIsSpcaEntered] = useState(false);
const targetPortal = React.useMemo(() => {
  const h = window.location.hostname.toLowerCase();
  if (h.includes('outreach'))                return 'outreach';
  if (h.includes('community') ) 
                                             return 'community';
  return 'inspectors';
}, []);
    // console.log(props.orderDescription)

    const steps = [
        'Select Campaign',
        vetName,
        'Add owner details',
        'Enter owner animals',
        'Issue voucher'
    ];

    useEffect(() => {
        FunctionsData.fetchDataGet(
            '/api/campaign/postcodes',
            setPostcodes,
            loadingPostcodes,
            setLoadingPostcodes
        )
    }, []);

    useEffect(() => {
        FunctionsData.fetchDataGetNoLoading(
            '/api/campaign/vets-community',
            setVets
        )
    }, [])

    useEffect(() => {

        let ac = googlePlace;

        setFormattedAddress(ac['address']);
        setPostcode(String(ac['POSTCODE']));
        setFrmCity(ac['TOWN_CITY_MAILTOWN']);
        setSuburb(ac['SUBURB_NAME']);
        setFrmStreet(ac['STREET_NAME']);
        setFrmDPID(ac['DPID']);
        setFrmStreetNumber(ac['STREET_NUMBER']);

    }, [googlePlace])

    useEffect(() => {
        // console.log('vet selection',currentVet,vets)
        if (currentVet !== 0) {
            let v = vets.find(({id}) => id === currentVet);
            setVetName('Vet: ' + v.business_name);
            setCurrentVetArr(v);
        }
    }, [currentVet])

    useEffect(() => {

        if (aStep === 0) {
            window.gtag('set', 'page_path', '/select_vet');
            window.gtag('event', 'page_view', {page_title: '#1 - Address search and vet selection'});
        }

        if (aStep === 1) {
            window.gtag('set', 'page_path', '/client_info');
            window.gtag('event', 'page_view', {
                page_title: "'#2 - Add" +
                    " client information'"
            });
        }

        if (aStep === 2) {
            window.gtag('set', 'page_path', '/add_animals');
            window.gtag('event', 'page_view', {page_title: "#3 - Add animals to order"});
        }

        if (aStep === 3) {
            window.gtag('set', 'page_path', '/finalise_order');
            window.gtag('event', 'page_view', {
                page_title: "#4 -" +
                    " Finalise order"
            });
        }

        if (aStep === 4) {
            window.gtag('set', 'page_path', '/order_sent');
            window.gtag('event', 'page_view', {
                page_title: "#5 - Order" +
                    " sent"
            });
        }

    }, [aStep])

    if (aStep === 0) {

        window.gtag('set', 'page_path', '#1 - Address search and vet selection');
        window.gtag('event', 'page_view');
        return (
            <div className={"form-container"}>
                <Steps steps={steps} aStep={aStep} />
                <CommunityStep {...props}
                                setcmpId = {setcmpId}
                                aStep={aStep}
                                setAStep={setAStep}
                                setStep={props.setStep}
                />
            </div>
        )
    }
    if (aStep === 1) {

        window.gtag('set', 'page_path', '#1 - Address search and vet selection');
        window.gtag('event', 'page_view');
        return (
            <div className={"form-container"}>
                <Steps steps={steps} aStep={aStep} />
                <CommunityStep0 {...props}
                                vets={vets} setVets={setVets}
                                postCode={postCode}
                                setPostCode={setPostcode}
                                aStep={aStep}
                                setAStep={setAStep}
                                setStep={props.setStep}
                                currentVet={currentVet}
                                setCurrentVet={setCurrentVet}
                                googlePlace={googlePlace}
                                setGooglePlace={setGooglePlace}
                                postcodes={postcodes}
                                ReactGA={props.ReactGA}
                                setSponsorId={setSponsorId} sponsorId={sponsorId}
                                setSponsorName={setSponsorName} sponsorName={sponsorName}
                                setSponsorProgram={setSponsorProgram} sponsorProgram={sponsorProgram}
                                setSponsorCost={setSponsorCost} sponsorCost={sponsorCost}
                                setSponsorMicrochipExtraCost={setSponsorMicrochipExtraCost}
                                sponsorMicrochipExtraCost={sponsorMicrochipExtraCost}
                                setSponsorEmailText={setSponsorEmailText} sponsorEmailText={sponsorEmailText}
                                setSponsorLogo={setSponsorLogo} sponsorLogo={sponsorLogo}
                                defaultLogo={defaultLogo}
                                cmpId = {cmpId}
                />
            </div>
        )
    }
    if (aStep === 2) {


        return (
            <div className={"form-container"}>
                <Steps steps={steps} aStep={aStep} />
                <CommunityStep1 {...props}
                                postCode={postCode} setPostCode={setPostcode}
                                aStep={aStep} setAStep={setAStep}
                                frmFn={frmFn} setFrmFn={setFrmFn}
                                frmLn={frmLn} setFrmLn={setFrmLn}
                                frmStreet={frmStreet} setFrmStreet={setFrmStreet}
                                frmStreetNumber={frmStreetNumber} setFrmStreetNumber={setFrmStreetNumber}
                                frmCity={frmCity} setFrmCity={setFrmCity}
                                frmEmail={frmEmail} setFrmEmail={setFrmEmail}
                                frmPhone={frmPhone} setFrmPhone={setFrmPhone}
                                userAccount={props.userAccount}

                />
            </div>
        )
    }

    if (aStep === 3) {


        return (
            <div className={"form-container"}>
                <Steps steps={steps} aStep={aStep} />
                <CommunityStep2 {...props}
                                aStep={aStep} setAStep={setAStep}
                                animals={animals} setAnimals={setAnimals}
                                frmCampaign={frmCampaign} setFrmCampaign={setFrmCampaign}
                                isSpcaEntered={isSpcaEntered} setIsSpcaEntered={setIsSpcaEntered}
                                cmpId = {cmpId}
                                frmEmail={frmEmail}
                                postCode={postCode}
                                ReactGA={props.ReactGA}
                                targetPortal={targetPortal}   
                                microchipOnly={props.microchipOnly} setMicrochipOnly={props.setMicrochipOnly}
                />
            </div>
        )
    }

    if (aStep === 4) {

        return (
            <div className={"form-container"}>
                <Steps steps={steps} aStep={aStep} />
                <CommunityStep3 {...props}
                                postcode={postCode}
                                aStep={aStep} setAStep={setAStep}
                                frmOrderID={frmOrderID} setFrmOrderID={setFrmOrderID}
                                frmFn={frmFn}
                                frmLn={frmLn}
                                frmStreet={frmStreet}
                                frmStreetNumber={frmStreetNumber}
                                frmCity={frmCity}
                                frmEmail={frmEmail}
                                frmPhone={frmPhone}
                                frmDPID={frmDPID}
                                suburb={suburb}
                                formattedAddress={formattedAddress}
                                animals={animals}
                                currentVetArr={currentVetArr}
                                frmMarketingOptin={frmMarketingOptin}
                                sponsorId={sponsorId}
                                sponsorName={sponsorName}
                                sponsorProgram={sponsorProgram}
                                sponsorCost={sponsorCost}
                                sponsorMicrochipExtraCost={sponsorMicrochipExtraCost}
                                sponsorEmailText={sponsorEmailText}
                                sponsorLogo={sponsorLogo}
                                orderDescription={props.orderDescription}
                                jwtKey={jwtKey} frmCampaign={frmCampaign}
                                microchipOnly={props.microchipOnly} setMicrochipOnly={props.setMicrochipOnly}
                                targetPortal={targetPortal}
                />
            </div>
        )
    }

    if (aStep === 5) {


        {
            return (
                <div className={"form-container"}>
                    <CommunityStep4Final
                        {...props}
                        animals={animals} setAnimals={setAnimals}
                        frmOrderID={frmOrderID}
                        currentVetArr={currentVetArr}
                        aStep={aStep} setAStep={setAStep}
                        jwtKey={jwtKey}
                        frmFn={frmFn}
                        frmLn={frmLn}
                        frmEmail={frmEmail}
                        ReactGA={props.ReactGA}
                        sponsorId={sponsorId}
                        sponsorName={sponsorName}
                        sponsorProgram={sponsorProgram}
                        sponsorCost={sponsorCost}
                        sponsorMicrochipExtraCost={sponsorMicrochipExtraCost}
                        sponsorEmailText={sponsorEmailText}
                        sponsorLogo={sponsorLogo}
                        orderDescription={props.orderDescription}
                        microchipOnly={props.microchipOnly} setMicrochipOnly={props.setMicrochipOnly}
                    />
                </div>
            )
        }
    }

    return null;
}

export default function LandingCommunity(props) {

    const [step, setStep] = useState(0);
    const [orderDescription, setOrderDescription] = useState('');

    const PageSelect = (props) => {
        if(step === 0 && props.outreach) return <OutreachStartPage {...props} step={step} setStep={setStep} ReactGA={props.ReactGA}/>
        if (step === 0) return <CommunityStartPage {...props} step={step} setStep={setStep} ReactGA={props.ReactGA}/>
        if (step === 1) return (
            <StepperComponent {...props} step={step} setStep={setStep} ReactGA={props.ReactGA}/>
        )
        return null;
    }

    if (step !== 0)
        return (
            <div className={"content"}>
                <img src={logo} style={{width: 150, marginTop: 20}}/>
                {props.microchipOnly && <div style={{color:'red'}}>This is a microchip only voucher.</div>}
                <Container maxWidth="lg" sx={{bgcolor: 'transparent', padding: 2, margin:0}}>
                    <PageSelect {...props} orderDescription={orderDescription}
                                setOrderDescription={setOrderDescription}/>
                    <ToastContainer/>
                </Container>
            </div>
        )

    return (
        <div className={"content"}>
            <img src={logo} style={{width: 450, marginTop: 0}}/>
            <Container maxWidth="lg" sx={{bgcolor: 'transparent', padding: 1}}>
                <PageSelect {...props} orderDescription={orderDescription} setOrderDescription={setOrderDescription}/>
                <ToastContainer/>
            </Container>
        </div>
    )
}

const Steps = ({aStep,steps}) => {

    return (
        <Stepper activeStep={aStep} alternativeLabel sx={{padding: 0, margin: 0}}>
            {steps.map((label) => (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            ))}
        </Stepper>
    )
}
